export default __webpack_public_path__ + "static/backgroundGallery-3fe3ef73dfbfbb91ab574063301245c6.jpg";